import { useContext } from "react";
import NotificationContext from "@/context/NotificationContext";

export default function useNotify() {
  const { notify } = useContext(NotificationContext);
  return notify;
}
